export function deepClone<T>(valueToClone: T): T {
  if (valueToClone == null) {
    return valueToClone;
  }
  return JSON.parse(JSON.stringify(valueToClone));
}

export const objectToBase64 = <T>(object: T): string => {
  const json = JSON.stringify(object);
  return btoa(encodeURIComponent(json));
};

export const base64ToObject = <T>(base64String: string): T => {
  const json = atob(base64String);
  return JSON.parse(decodeURIComponent(json));
};

export const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  const uint8Array = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < uint8Array.byteLength; i++) {
    binary += String.fromCharCode(uint8Array[i]!);
  }
  return btoa(binary);
};

export const blobToDataURL = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const dataURLToFile = (base64Data: string, filename: string, mimeType: string, lastModified?: number): File => {
  const byteString = atob(base64Data.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new File([ab], filename, { type: mimeType, ...(lastModified !== undefined ? { lastModified } : {}) });
};

export const notEmptyObject = (obj: string | Record<string, unknown> | unknown[] | undefined | null): boolean => {
  if (obj && obj !== "undefined") {
    if (Array.isArray(obj)) {
      if (obj.length > 0) {
        return true;
      }
    } else {
      return true;
    }
  }
  return false;
};
